export const defaultColumns = [
  { label: 'Nome', value: 'display_name' },
  { label: 'Ação', value: 'action', className: 'w-9' },
]
